export class GoToCreditTabEvent {}
